import React, {Component} from 'react';
import ContentPanel from '../../components/ContentPanel/ContentPanel';
import Skeleton from '../../components/Skeleton/Skeleton';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import {REQUEST_SHIPPING_ADVISORY_DATA} from "../../actions/shippingAdvisoryActions";
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import ContentLinkRenderer from '../../components/ContentLinkRenderer/ContentLinkRenderer';
import ContentRenderer from "../../components/ContentRenderer/ContentRenderer";
import moment from "moment";


const mapStateToProps = state => {
  return {
    shippingAdvisoryData: state.shippingAdvisoryData
  }
};

const mapDispatchToProps = dispatch => ({
  getShippingAdvisoryData: () => dispatch({type: REQUEST_SHIPPING_ADVISORY_DATA})
});

class ShippingAdvisory extends Component {

  componentDidMount() {
    if (!Object.keys(this.props.shippingAdvisoryData).length) {
      this.props.getShippingAdvisoryData();
    }
  };

  getShippingAdvisoryView = () => {
    return (
      <div className="wrapper">
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/ship/page-components/text-block/shipping-advisory-heading.html"
        />
        <div className="cards-list__archive-block-container mtm">
          {
            this.props.shippingAdvisoryData.advisories
              .sort((a, b) => {
                const timestampA = moment(a.date, 'MM/DD/YYYY').unix();
                const timestampB = moment(b.date, 'MM/DD/YYYY').unix();
                return timestampB - timestampA;
              })
              .map((item, index) => {
                return (
                  <div key={index} className="cards-list__archive-block cards-list__archive-block--news">
                    <div key={index} className="cards-list__archive-item">
                      <p className="cards-list__archive-item-date">{item.date}</p>
                      {
                        (item.detailContent && item.detailContent.type && item.detailContent.value) ?
                          <ContentLinkRenderer
                            contentType={item.detailContent.type}
                            value={item.detailContent.value}
                            linkContent={item.title}
                            className="cards-list__archive-item-title-link"
                            target={item.detailContent.target}
                            pathForItem="/shipping-advisory/advisory-item"
                            id={item.id}
                          />
                          :
                          <p className="cards-list__archive-item-title-link mtn">{item.title}</p>
                      }
                    </div>
                    {
                      (item.content && item.content.type && item.content.value) ?
                        <ContentRenderer
                          contentType={item.content.type}
                          value={item.content.value}
                        />
                        :
                        null
                    }
                  </div>
                )
              })
          }
        </div>
      </div>
    )
  };

  render() {
    if (!Object.keys(this.props.shippingAdvisoryData).length) {
      return (<Skeleton type="IFRAME"/>)
    } else {
      return this.getShippingAdvisoryView();
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShippingAdvisory));



// WEBPACK FOOTER //
// ./src/pages/ship/ShippingAdvisory.js